import { render, staticRenderFns } from "./label-product-select.vue?vue&type=template&id=770f04ba&"
import script from "./label-product-select.vue?vue&type=script&lang=js&"
export * from "./label-product-select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports